import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const WarningIcon: FC<SVGProps<SVGSVGElement>> = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor"><path fillRule="evenodd" clipRule="evenodd" d="M4.81409 20.4368H19.1971C20.7791 20.4368 21.7721 18.7268 20.9861 17.3528L13.8001 4.78781C13.0091 3.40481 11.0151 3.40381 10.2231 4.78681L3.02509 17.3518C2.23909 18.7258 3.23109 20.4368 4.81409 20.4368Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" /><path d="M12.0027 13.4148V10.3148" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><path d="M11.995 16.5H12.005" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};